import { Box, styled } from '@mui/material';

export const AppointmentsOverviewPageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4)
}));

export const AppointmentsOverviewHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0, 4, 0)
}));

export const AppointmentsOverviewFiltersContainer = styled(Box)(
  ({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
    minWidth: 0
  })
);

export const AppointmentsOverviewParticipantFilter = styled(Box)(
  ({ theme }) => ({
    justifySelf: 'start',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minHeight: 56,
    minWidth: 0
  })
);

export const AppointmentsOverviewDateNavigationContainer = styled(Box)({
  justifySelf: 'center'
});

export const AppointmentsOverviewSelectedParticipant = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    maxWidth: 400
  })
);

export const AppointmentsOverviewSelectedParticipantLabel = styled(Box)(
  ({ theme }) => ({
    fontWeight: 500,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexGrow: 1,
    minWidth: 0,
    fontSize: theme.typography.body1.fontSize
  })
);
